import { supabase } from "@/integrations/supabase/client";

export interface Department {
  id: string;
  name: string;
  description?: string;
  color: string;
  company_id: string;
  created_at: string;
  updated_at: string;
  policy_count?: number;
}

/**
 * Fetch all departments for a company
 */
export async function fetchDepartments(companyId: string): Promise<Department[]> {
  const { data, error } = await supabase
    .from('departments')
    .select('*')
    .eq('company_id', companyId)
    .order('name');

  if (error) {
    console.error('Error fetching departments:', error);
    throw error;
  }

  return data || [];
}

/**
 * Get department color by name
 */
export async function getDepartmentColor(companyId: string, departmentName: string): Promise<string | null> {
  const { data, error } = await supabase
    .from('departments')
    .select('color')
    .eq('company_id', companyId)
    .eq('name', departmentName)
    .single();

  if (error) {
    console.error('Error fetching department color:', error);
    return null;
  }

  return data?.color || null;
}

/**
 * Get all department colors as a map
 */
export async function getDepartmentColorsMap(companyId: string): Promise<Record<string, string>> {
  const departments = await fetchDepartments(companyId);
  const colorsMap: Record<string, string> = {};
  
  departments.forEach(dept => {
    colorsMap[dept.name] = dept.color;
  });
  
  return colorsMap;
}

/**
 * Format department name for display
 */
export function getDepartmentDisplay(department: string): string {
  return department.charAt(0).toUpperCase() + department.slice(1).replace(/_/g, ' ');
}
